 if (window.innerWidth <= 1024){
        observeVisibility($(".productPurchaseModuleMobile"), handleEnter, handleExit,0);
        function handleEnter() {
            // 移除
            $('.mobileProduct-bottomAddCart').css('display','none');
        }

        function handleExit(){
            // 添加
            $('.mobileProduct-bottomAddCart').css('display','flex');
        }
    }